import { SvgIcon } from "@material-ui/core";
import React from "react";

const HalterIcon = (props) => {
  return (
    <SvgIcon
      style={{
        fontSize: 24,
      }}
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.03 28.03">
        <path d="M24.9,14.54H19L13.49,9V3.12a2.93,2.93,0,0,0-5-2.07L1.05,8.48a2.93,2.93,0,0,0,2.07,5H9L14.54,19v5.9a2.93,2.93,0,0,0,5,2.08L27,19.55A2.93,2.93,0,0,0,24.9,14.54Z" />
        <path d="M27.6,23.29a.67.67,0,0,0-1-.11l-3.38,3.38a.67.67,0,0,0,.11,1,3.15,3.15,0,0,0,4.31-4.31Z" />
        <path d="M1.47,4.84,4.84,1.47a.66.66,0,0,0-.1-1A3.15,3.15,0,0,0,.43,4.74.66.66,0,0,0,1.47,4.84Z" />
      </svg>
    </SvgIcon>
  );
};

export default HalterIcon;
